// @flow

import React from 'react';
import type { Node } from 'react';
import styled, { css } from 'styled-components';
import type { AllImages } from 'hooks/use-images';
import { useImages } from 'hooks';
import { ImageLoader } from 'components/Gui';
import { flex, h201520, topPadding, Width, widths } from 'styles';

const Wrapper = styled.section`
  ${topPadding(116, 58, 84)};

  h2 {
    text-align: center;

    @media print, screen and (min-width: ${Width.BREAK_MD}px) {
      white-space: unset;
    }
  }
`;

const List = styled.div`
  margin-top: 40px;

  @media print, screen and (min-width: ${Width.BREAK_MD}px) {
    margin-top: 24px;
    ${flex('space-between', 'flex-start')};
  }

  @media print, screen and (min-width: ${Width.BREAK_XL}px) {
    margin-top: 50px;
  }

  > div {
    ${flex()};
    flex-direction: column;
    text-align: center;
    max-width: 380px;
    margin: 0 auto;

    @media print, screen and (min-width: ${Width.BREAK_MD}px) {
      flex: 0 0 auto;
      width: calc(90% / 3);
      max-width: unset;
      margin: unset;
    }

    h3 {
      ${h201520};
      margin-bottom: 16px;
    }
  }
`;

const Image = styled.div`
  margin-bottom: 6px;
  ${({ imageWidth }) =>
    Array.isArray(imageWidth)
      ? css`
          ${widths(...imageWidth)}
        `
      : css`
          width: ${imageWidth}px;
        `};
`;

type Props = {
  title: Node,
  items: {
    image: {
      name: string,
      alt: string,
    },
    text: Node,
  }[],
  imageWidth: number | number[],
  images: AllImages,
};

const ThreeItemImageBlurbList = ({ title, items, imageWidth, images, ...rest }: Props) => {
  const getImage = useImages(images);
  return (
    <Wrapper {...rest}>
      {title}
      <List role="list">
        {items.map(({ image: { name, alt }, text }, index) => (
          <div key={`ImageBlurbList-${index}`} role="listitem">
            <Image imageWidth={imageWidth}>
              <ImageLoader image={getImage(name)} alt={alt} />
            </Image>
            {text}
          </div>
        ))}
      </List>
    </Wrapper>
  );
};

export default ThreeItemImageBlurbList;
